<template>
  <div class="main">
    <Form
      style="max-width: 500px; margin: 40px auto 0;"
      ref="form"
      :model="form"
      :rules="validatorRules"
    >
      <form-item props="username">
        <i-input size="large" v-model="form.username" type="text" autocomplete="false" placeholder="请输入用户账号或手机号"></i-input>
      </form-item>
      <form-item props="inputCode">
        <Row type="flex">
          <i-col span="14">
            <i-input size="large" type="text" @on-change="inputCodeChange" placeholder="请输入验证码"></i-input>
          </i-col>
          <i-col span="10" style="text-align: right">
            <img style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode" />
          </i-col>
        </Row>
      </form-item>
      <form-item>
        <a 
         class="submit"
          type="primary"
          @click="nextStep">下一步</a>
      </form-item>
    </Form>
  </div>
</template>

<script>
import request from "@/api/axios";
import { checkOnlyUser } from "@/api/index";

export default {
  name: "Step1",
  data() {
    return {
      form: {
        username: "",
        inputCode: "",
      },
      inputCodeContent: "",
      inputCodeNull: true,
      verifiedCode: "",
      validatorRules: {
        username: {
          rules: [
            { required: false },
            { validator: this.validateInputUsername },
          ],
        },
        inputCode: { rules: [{ required: true, message: "请输入验证码!" }] },
      },
      randCodeImage: "",
      requestCodeSuccess: true,
      currdatetime: "",
    };
  },
  created() {
    this.handleChangeCheckCode();
  },
  methods: {
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      request({ url: `/api/sys/randomImage/${this.currdatetime}`, method: "get" })
        .then((res) => {
          if (res.success) {
            this.randCodeImage = res.result;
            this.requestCodeSuccess = true;
          } else {
            this.$message.error(res.message);
            this.requestCodeSuccess = false;
          }
        })
        .catch(() => {
          this.requestCodeSuccess = false;
        });
    },
    nextStep() {
      let that = this;
      let isPhone = false;
      var params = {};
      var reg = /^1[34578]\d{9}$/;
      var username = that.form.username;
      if (reg.test(username) == true) {
        params.phone = username;
        isPhone = true;
      } else {
        params.username = username;
      }
      that.validateInputCode().then(() => {
        request({
          url: "/api/sys/user/querySysUser",
          method: "get",
          params: params,
        }).then((res) => {
          if (res.success) {
            var userList = {
              username: res.result.username,
              phone: res.result.phone,
              isPhone: isPhone,
            };
            setTimeout(function () {
              that.$emit("nextStep", userList);
            });
          }else{
            this.$Message.error("用户名或手机号错误");
          }
        });
      });
    },
    validateInputCode() {
      return new Promise((resolve, reject) => {
        request({
          url: "/api/sys/checkCaptcha",
          method: "post",
          data: {
            captcha: this.inputCodeContent,
            checkKey: this.currdatetime,
          },
        }).then((res) => {
          if (res.success) {
            resolve();
          } else {
            this.$Message.error(res.message);
            reject();
          }
        });
      });
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value;
      console.log(this.inputCodeContent);
      if (!e.target.value || 0 == e.target.value) {
        this.inputCodeNull = true;
      } else {
        this.inputCodeContent = this.inputCodeContent.toLowerCase();
        this.inputCodeNull = false;
      }
    },
    generateCode(value) {
      this.verifiedCode = value.toLowerCase();
      console.log(this.verifiedCode);
    },
    validateInputUsername(rule, value, callback) {
      console.log(value);
      var reg = /^[0-9]+.?[0-9]*/;
      if (!value) {
        callback("请输入用户名和手机号！");
      }

      //判断用户输入账号还是手机号码
      if (reg.test(value)) {
        var params = {
          phone: value,
        };
        checkOnlyUser(params).then((res) => {
          if (res.success) {
            callback("用户名不存在!");
          } else {
            callback();
          }
        });
      } else {
        var params = {
          username: value,
        };
        checkOnlyUser(params).then((res) => {
          if (res.success) {
            callback("用户名不存在!");
          } else {
            callback();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
    .submit {
      height: 45px;
      line-height: 45px;
      background: rgba(0, 193, 222, 1);
      width: 100%;
      display: block;
      color: #fff;
      text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/Step1.vue